// extracted by mini-css-extract-plugin
export var licenseInformationHeadline = "license-information__headline_KIkEahROnqikGO0atLRt";
export var licenseInformationLicenseState = "license-information__license-state_xFWeO8omGqTF3YfTznsA";
export var licenseInformationLicenseStateActive = "license-information__license-state_active_y6GjrdHvy70CHCbO4sGr";